<form class="col-12 mt-5 ps-0" [formGroup]="formulario">
  <div class="row">
    <div class="col-12 col-lg-4 mb-0 mb-lg-4">
      <div class="mb-3">
        <label class="label-menor" for="inputCep">CEP</label>
        <input type="text" class="form-control" id="inputCep" mask="00000-000"
          formControlName="codigoCep" placeholder="00000-000">
      </div>
    </div>
    @if (consultaCep === null || consultaCep === false) {
      <div class="col-12 mb-4">
        @if (consultaCep === null) {
          <div>
            <div class="text-start">
              <output>
                <div class="spinner-border c-primary">
                  <span class="visually-hidden">Consultando CEP ...</span>
                </div>
              </output>
            </div>
            <p class="legenda-spinner text-start">Consultando CEP ...</p>
          </div>
        }
        @if (consultaCep === false) {
          <p class="legenda-erro">Erro na consulta. Verifique o CEP.</p>
        }
      </div>
    }
  </div>

  <div class="row">
    <div class="col-12 col-md-12 col-lg-5 col-xl-6 mb-4">
      <div class="mb-3">
        <label class="label-menor" for="inputLogradouro">LOGRADOURO</label>
        <input type="text" class="form-control" id="inputLogradouro" formControlName="descricaoLogradouro"
          placeholder="Preencha com o endereço">
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-4">
      <div class="mb-3">
        <label class="label-menor" for="inputNumero">NÚMERO</label>
        <input type="text" class="form-control" id="inputNumero" formControlName="codigoNumero" placeholder="Número">
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4 col-xl-4 mb-4">
      <div class="mb-3">
        <label class="label-menor" for="inputComplemento">COMPLEMENTO</label>
        <input type="text" class="form-control" id="inputComplemento" formControlName="codigoComplemento"
          placeholder="Complemento">
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-3 col-xl-3 mb-4">
      <div class="mb-3">
        <label class="label-menor" for="inputBairro">BAIRRO</label>
        <input type="text" class="form-control" id="inputBairro" formControlName="codigoBairro"
          placeholder="Digite o bairro">
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-3 col-xl-3 mb-4">
      <div class="mb-3">
        <label class="label-menor" for="inputCidade">CIDADE</label>
        <input type="text" class="form-control" id="inputCidade" formControlName="codigoCidade"
          placeholder="Selecione a cidade">
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-4">
      <div class="mb-3">
        <label class="label-menor" for="inputEstado">ESTADO</label>
        <input type="text" class="form-control" id="inputEstado" formControlName="codigoEstado" placeholder="Estado">
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4 col-xl-4 mb-4">
      <div class="mb-3">
        <fieldset class="border-0 p-0">
          <legend class="label-menor">TIPO</legend>
          <div class="form-check form-check-inline">
            <input type="radio" id="endFormEntrega" class="form-check-input" value="entrega"
              formControlName="codigoTipoEndereco" name="codigoTipoEndereco">
            <label class="form-check-label" for="endFormEntrega">Entrega</label>
          </div>
          <div class="form-check form-check-inline">
            <input type="radio" id="endFormFaturamento" class="form-check-input" value="faturamento"
              formControlName="codigoTipoEndereco" name="codigoTipoEndereco">
            <label class="form-check-label" for="endFormFaturamento">Faturamento/entrega</label>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-6 mb-4">
      <div class="mb-3">
        <label class="label-menor" for="inputReferencia">LOCAL DE REFERÊNCIA</label>
        <input type="text" class="form-control" id="inputReferencia" formControlName="descricaoReferencia"
          placeholder="Preencha com o local de referência">
      </div>
    </div>
  </div>

  @if (mostrarResponsaveis) {
    @for (i of [1,2,3]; track i) {
      <div class="row">
        <div class="col-12 col-md-6 col-lg-6 mb-4">
          <div class="mb-3">
            <label class="label-menor" [for]="'inputNomeRespon' + i">{{i}} - INDICADO PARA O RECEBIMENTO</label>
            <input type="text" class="form-control" [id]="'inputNomeRespon' + i"
              [formControlName]="'nomeRespon' + i" placeholder="Nome do responsável">
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 mb-4">
          <div class="mb-3">
            <label class="label-menor" [for]="'inputTelefoneRespon' + i">TELEFONE</label>
            <input type="text" class="form-control" [id]="'inputTelefoneRespon' + i"
              [formControlName]="'telefoneRespon' + i" placeholder="(XX) XXXX-XXXX"
              mask="(00)00000-0000" [dropSpecialCharacters]="true" [validation]="false">
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 mb-4">
          <div class="mb-3">
            <label class="label-menor" [for]="'inputRamalRespon' + i">RAMAL</label>
            <input type="number" (keypress)="somenteNumeros($event)" class="form-control"
              [id]="'inputRamalRespon' + i" [formControlName]="'ramalTelefonRespon' + i"
              placeholder="Número Ramal">
          </div>
        </div>
      </div>
    }
  }
</form>

@if (mensagemErro) {
  <p class="legenda-erro mt-3 mb-4">{{mensagemErro}}</p>
}
